var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-game position-relative"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":false,"background-color":"#EBEDEF","height":60,"width":60,"color":"#CC3636","loader":"dots"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }